import {
	START_FETCH_SERVICE_SETTING,
	FETCH_SERVICE_SETTING_SUCCESS,
	FETCH_SERVICE_SETTING_FAILED,

	UPDATE_SERVICE_SETTING,
} from './action-types';

export function fetchServiceSettingAction() {
	return {
		type: START_FETCH_SERVICE_SETTING,
	};
}

export function fetchServiceSettingSuccessAction(serviceSetting) {
	return {
		type: FETCH_SERVICE_SETTING_SUCCESS,
		serviceSetting,
	};
}

export function fetchServiceSettingFailedAction(error, errorMessage) {
	return {
		type: FETCH_SERVICE_SETTING_FAILED,
		error,
		errorMessage,
	};
}

export function updateServiceSettingAction(serviceSetting) {
	return {
		type: UPDATE_SERVICE_SETTING,
		serviceSetting,
	};
}
